<template>
  <div class="tmn-quotes-page">
    <vx-card id="crash-loading" class="w-full crash-loading first-loading-wdma"
      v-if="!displayCannotLoadSystem && initComponentLoading && !hasSessionClose && !displayMaxConnections">
      <div class="logo-full logo-loading-wdma mt-5"></div>
      <div class="">
        <div class="content-quotes">
          <div class="mt-5 mb-5">
            <div class="loading-bar">
              <span class="background-loading-bar">
                <span class="loading-bar-inner progress-bar-stripes"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <!-- CANNOT LOAD SYSTEM ERROR -->
    <TMNErrorPage v-if="displayCannotLoadSystem && !initComponentLoading && !hasSessionClose && !displayMaxConnections"
      :title="$t('WDMA').Error_System_Title" :desc="$t('WDMA').Error_System_Subtitle" :displayLoadingBar="true"
      :btnConnectText="$t('WDMA').Error_System_Button_Update" :currentErrorCode="currentErrorCode"
      @connect="requestNewToken" @openAttendance="openAttendance"></TMNErrorPage>

    <!-- ON SESSION CLOSE -->
    <TMNErrorPage v-if="hasSessionClose" :title="$t('WDMA').Error_System_Title_Session_Close"
      :desc="$t('WDMA').Error_Session_Close" :currentErrorCode="currentErrorCode" @connect="sessionCloseRefresh"
      @openAttendance="openAttendance"></TMNErrorPage>

    <!-- MAX CONNECTION -->
    <TMNErrorPage v-if="displayMaxConnections" :title="$t('WDMA').Error_Title_Max_Simultaneous_Connections"
      :desc="$t('WDMA').Error_Max_Simultaneous_Connections" :currentErrorCode="currentErrorCode"
      @connect="sessionCloseRefresh" @openAttendance="openAttendance"></TMNErrorPage>

    <!-- INVALID CREDENTIALS -->
    <TMNErrorPage v-if="displayInvalidCredentials" :title="$t('WDMA').Error_Title_Invalid_Credentials"
      :desc="$t('WDMA').Error_Invalid_Credentials" :currentErrorCode="currentErrorCode" @connect="sessionCloseRefresh"
      @openAttendance="openAttendance"></TMNErrorPage>

    <div id="quotes-content"
      v-show="!displayCannotLoadSystem && !initComponentLoading && !hasSessionClose && !displayMaxConnections">

    </div>
  </div>
</template>

<script>
// import WDMA from "../../../assets/lib/cma-wdma-sdk.js";
// import * as WDMA_Mobile from "../../../assets/lib/cma-wdma-sdk-mobile.js";
import localStorageHelper from "../../../helpers/local-storage-helper";
import acceptorService from "../../../providers/acceptorService";
import layoutService from "../../../providers/layoutService";
import tmnHelper from "../../../helpers/tmn-helper";
// import { logger } from '../../../providers/appLogger';
import { getWdmaLocale } from "../../../helpers/locale-helper.js";
import messagesNotifyHelper from "../../../helpers/messages-notify-helper.js";
import messageDialogHelper from "../../../helpers/message-dialog-helper.js";
import { EventBus } from "../../../event-bus.js";
import AppConstants from "../../../appConstants.js";
import VxCard from "../../../components/vx-card/VxCard.vue";
import authService from '../../../providers/authService.js';
import { getRandomNumberMinMax } from "../../../@core/utils/utils.js";
import checkDeviceTypeHelper from "../../../helpers/check-device-type-helper.js";
import TMNErrorPage from "./TMNErrorPage.vue";

let WDMA = null;

export default {
  components: {
    VxCard,
    TMNErrorPage
  },
  name: "quotes",
  props: {
    // currentCommodity: {
    //   required: false,
    //   type: Object
    // },
    // currentContent: {
    //   required: false,
    //   type: Object
    // }
  },
  data() {
    return {
      connStatus: "",
      conversionComm: {
        "Todas Commodities": ["Todos", "TodosEUA", "TodosESP", "TodosARG", "TodosARG", "TodosARG", "TodosARG", "TodosARG", "TodosARG", "TodosPOR"],
        "Acucar-Alcool": ["Acucar-Alcool", "AcucarEUA", "Acucar-Alcool", "Acucar-Alcool", "Acucar-Alcool", "Acucar-Alcool", "Acucar-Alcool", "Acucar-AlcoolMEX", "Acucar-Alcool", "Acucar-AlcoolPOR"],
        Algodao: ["Algodao", "Algodao", "Algodao", "Algodao", "Algodao", "Algodao", "Algodao", "Algodao", "Algodao", "Algodao"],
        Arroz: ["Arroz", "Arroz", "ArrozESP", "Arroz", "Arroz", "Arroz", "Arroz", "ArrozMEX", "Arroz", "ArrozPOR"],
        Biodiesel: ["Biodiesel", "Biodiesel", "Biodiesel", "Biodiesel", "Biodiesel", "Biodiesel", "Biodiesel", "Biodiesel", "Biodiesel", "Biodiesel"],
        Boi: ["Boi", "BoiEUA", "BoiESP", "BoiARG", "BoiARG", "BoiARG", "BoiARG", "BoiARG", "BoiARG", "BoiPOR"],
        Cafe: ["Cafe", "CafeEUA", "CafeESP", "CafeARG", "CafeARG", "CafeARG", "CafeARG", "CafeMEX", "CafeCOL", "CafePOR"],
        Chicago: ["Chicago", "Chicago", "Chicago", "Chicago", "Chicago", "Chicago", "Chicago", "Chicago", "Chicago", "Chicago"],
        Farelo: ["Farelo", "FareloEUA", "FareloESP", "FareloARG", "FareloARG", "FareloARG", "FareloARG", "FareloMEX", "FareloCOL", "FareloPOR"],
        Feijao: ["Feijao", "Feijao", "Feijao", "Feijao", "Feijao", "Feijao", "Feijao", "Feijao", "Feijao", "Feijao"],
        Frango: ["Frango", "FrangoEUA", "FrangoESP", "FrangoARG", "FrangoARG", "FrangoARG", "FrangoARG", "FrangoARG", "FrangoARG", "FrangoPOR"],
        Latam: ["Latam", "Latam", "Latam", "Latam", "Latam", "Latam", "Latam", "Latam", "Latam", "Latam"],
        Milho: ["Milho", "MilhoEUA", "MilhoESP", "MilhoARG", "MilhoARG", "MilhoARG", "MilhoARG", "MilhoMEX", "MilhoCOL", "MilhoPOR"],
        Soja: ["Soja", "SojaEUA", "SojaESP", "SojaARG", "SojaARG", "SojaARG", "SojaARG", "SojaMEX", "SojaCOL", "SojaPOR"],
        Suino: ["Suino", "SuinoEUA", "SuinoESP", "SuinoARG", "SuinoARG", "SuinoARG", "SuinoARG", "SuinoARG", "SuinoARG", "SuinoPOR"],
        Trigo: ["Trigo", "TrigoEUA", "TrigoESP", "TrigoARG", "TrigoARG", "TrigoARG", "TrigoARG", "TrigoMEX", "TrigoCOL", "TrigoPOR"],
        Fertilizantes: ["Fertilizantes", "Fertilizantes", "FertilizantesESP", "FertilizantesARG", "FertilizantesARG", "FertilizantesARG", "FertilizantesARG", "FertilizantesMEX", "FertilizantesCOL", "FertilizantesPOR"]
      },
      conversionContent: {
        pt: {
          "Mercado Físico": "Fisico",
          "Câmbio, Forex & NDF": "Cambio",
          Indicadores: "Indicadores",
          "Mercado Futuro": "Futuro",
          "Meus Ativos": "Meus Ativos"
        },
        en: {
          "Physical Market": "Fisico",
          "Exchange & Forex": "Cambio",
          Indicators: "Indicadores",
          "Future Market": "Futuro",
          "My Assets": "Meus Ativos"
        },
        es: {
          "Mercado Físico": "Fisico",
          "Cambio & Forex": "Cambio",
          Indicadores: "Indicadores",
          "Mercado Futuro": "Futuro",
          "Mis Activos": "Meus Ativos"
        }
      },
      tmnsdk: null,
      currentRoute: "",
      subjects: [],
      subjectsTmn: new Map([
        ["Acucar-Alcool", "Acucar-Alcool"],
        ["Algodao", "Algodao"],
        ["Arroz", "Arroz"],
        ["Biodiesel", "Biodiesel"],
        ["Boi", "Boi"],
        ["Cafe", "Cafe"],
        ["Feijao", "Feijao"],
        ["Frango", "Frango"],
        ["Milho", "Milho"],
        ["Soja", "Soja"],
        ["Suino", "Suino"],
        ["Trigo", "Trigo"],
        ["Fertilizantes", "Fertilizantes"]
      ]),
      displayCannotLoadSystem: false,
      displayMaxConnections: false,
      displayInvalidCredentials: false,
      refreshToken: '',
      requestingToken: false,
      initComponentLoading: true,
      checkTokenInterval: null,
      hasSessionClose: false,
      currentErrorCode: null
    };
  },
  watch: {
    currentLang(val) {
      this.currentLang = val;
      console.log("[TmnQuotes] set lang: ", this.currentLang);
      if (this.tmnsdk) {
        this.tmnsdk.setLanguage(this.currentLang);
      }
    },
    routeTheme(val) {
      console.log('[routeTheme]', this.routeTheme);
      // console.log('[val]', val);
      // if (this.routeTheme == val) return;
      // console.log('[routeTheme][setTheme][before]', this.routeTheme);
      // this.routeTheme = val;
      // console.log('[routeTheme][setTheme][after]', this.routeTheme);
      if (this.tmnsdk) {
        console.log('[setTheme]', val);
        this.tmnsdk.setTheme(val);
      }
    },
    currentCommodity(value) {
      // has updated commodity, send update to tmn
      if (value) {
        // console.log("commodity: ", value.mne);
        console.log("[currentCommodity]", value);

        if (!tmnHelper.isTmnContent(this.currentContent)) {
          return;
        }

        const url = this.getUrlComm(value, this.currentContent.nome);
        if (url) {
          this.currentRoute = url;
          // console.log(`currentCommodity this.tmnsdk.navigate: 1. ${this.currentRoute}`);
          if (this.tmnsdk) {
            this.tmnsdk.navigate(this.currentRoute);
          }
        }
      }
    },
    currentContent(value) {
      if (!tmnHelper.isTmnContent(value)) {
        return;
      }
      console.log("[currentContent]", value);
      const url = this.getUrlComm(this.currentCommodity, value.nome);
      if (url) {
        this.currentRoute = url;
        // console.log(`currentContent this.tmnsdk.navigate: 1. ${this.currentRoute}`);
        if (this.tmnsdk) {
          console.log("[currentContent][navigate]", this.currentRoute);
          this.tmnsdk.navigate(this.currentRoute);
        }
      }
    }
  },
  computed: {
    quotesContentList() {
      return this.$store.state.quotesContentList;
    },
    currentCommodity() {
      return this.$store.state.currentCommodity;
    },
    currentContent() {
      return this.$store.state.currentContent;
    },
    reduceSidebar() {
      return this.$store.state.contentSubmenuReduceSidebar;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    isDesktop() {
      // return this.$store.state.isDesktop;
      return !checkDeviceTypeHelper.isNativeApp();
    },
    currentLang: {
      get() {
        return getWdmaLocale(this.$i18n.locale);
      },
      set(val) { }
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    commodityRights() {
      return this.$store.state.AppActiveUser.rights;
    },
    routeTheme: {
      get() {
        if (this.$store.state.theme === "dark") {
          return "dark";
        } else {
          if (!this.isDesktop) {
            return "normal";
          }
          return "light";
        }
      },
      set(val) { }
    }
  },
  created() {
    console.log('[tmnquotes][created]')
    WDMA = require("../../../assets/lib/cma-wdma-sdk.js").default;
    // if (this.isDesktop) {
    //   WDMA = require("../../../assets/lib/cma-wdma-sdk.js").default;
    // } else {
    //   WDMA = require("../../../assets/lib/cma-wdma-sdk-mobile.js").default;
    // }
    const TMNCommodity = this.$route.query.currentCommodity;
    const TMNContent = this.$route.query.currentContent;

    this.setVisibilityDetachedWindow(TMNCommodity, TMNContent);

    // commented in 2023-12-27
    // const url = this.getUrlComm(TMNCommodity, TMNContent);
    // if (url) {
    //   this.currentRoute = url;
    //   // console.log(`currentCommodity this.tmnsdk.navigate: 1. ${this.currentRoute}`);
    //   // this.tmnsdk.navigate(this.currentRoute);
    // }
  },
  async mounted() {
    // this.initCheck();
    console.log('[mounted]')
    // logger.logToServer({content: 'WDMA mounted', user: this.getCurrentUser()});
    console.log('[TMNQuotes] mounted component');

    this.subjects = this.getSubjects();

    const { acpurl, acptoken, domain } = this.getCurrentUser();
    console.log(
      "[mounted]",
      `url: ${acpurl}, token: ${acptoken}, domain: ${domain}`
    );
    // console.log('[checkAcceptorCredentials]', this.checkAcceptorCredentials(acpurl, acptoken, domain))
    if (!acptoken && !acpurl && !domain) {
      this.requestNewToken();
    } else {
      console.log('[ACCEPTOR] init check token');
      this.checkToken(true);
      // try {
      //   // Logout acceptor
      //   // console.log('[ACCEPTOR] init logout');
      //   // // authService.logoutAcceptor().then(() => {
      //   // //   // console.log('loading with local data');
      //   // //   // this.processToken({token: acptoken, url: acpurl, domain: domain})
      //   // //   // this.initWDMA(acpurl, acptoken, domain);
      //   // // });
      //   // try {
      //   //   await this.logoutAcceptor();
      //   // } catch (error) {
      //   //   console.warn('[ACCEPTOR][ERROR][LOGOUT]', error);
      //   // }
      //   // setTimeout(() => {
      //   //   this.requestNewToken();
      //   // }, 2000);
      // } catch (error) {
      //   this.requestNewToken();
      // }

    }

    EventBus.$on(AppConstants.BUS_EVENT_CHECK_ACCEPTOR_TOKEN, () => {
      this.checkToken(false);
    });
    EventBus.$on(AppConstants.BUS_EVENT_RESTORE_LAYOUT_QUOTES, () => {
      console.log('[TMNQuotes] restore layout');
      this.restoreLayout();
    });
    EventBus.$on(AppConstants.BUS_EVENT_CLEAR_LOCAL_DATA_QUOTES, () => {
      console.log('[TMNQuotes] clear local data');
      this.clearLocalData();
    });
    EventBus.$on(AppConstants.BUS_EVENT_UPDATE_HIST_LAYOUT_QUOTES, (layoutHist) => {
      console.log('[TMNQuotes] update hist layout', layoutHist);
      this.updateHistLayout(layoutHist);
    });
  },
  async destroyed() {
    console.log('[Destroyed]');
    EventBus.$off(AppConstants.BUS_EVENT_CHECK_ACCEPTOR_TOKEN);
    EventBus.$off(AppConstants.BUS_EVENT_RESTORE_LAYOUT_QUOTES);
    EventBus.$off(AppConstants.BUS_EVENT_CLEAR_LOCAL_DATA_QUOTES);
    EventBus.$off(AppConstants.BUS_EVENT_UPDATE_HIST_LAYOUT_QUOTES);
    if (this.isWindowDetached) {
      try {
        await this.logoutAcceptor();
      } catch (error) {
        console.warn('[ACCEPTOR][ERROR][LOGOUT]', error);
      }
    }
  },
  methods: {
    async updateLayout(layout, metadata) {
      if (layout && metadata) {
        localStorageHelper.updateMetadata(metadata);
        const form = {
          layout: layout,
          metadata: metadata
        };

        try {
          const resp = await layoutService.saveLayoutWDMA(form, new URLSearchParams())
          if (resp) {
            console.log("layout saved");
            return true;
          }
        } catch (error) {
          console.log("Error change layout", error);
        }
        return false;
      }
    },
    async updateHistLayout(layoutHist) {
      // this.$store.commit('TOGGLE_CONTENT_OVERLAY', true);
      console.log('[updateHistLayout]', layoutHist);
      if (layoutHist && layoutHist._id && this.tmnsdk) {
        try {
          const respLayHist = await layoutService.findOneLayoutHistWDMA(layoutHist._id, new URLSearchParams())
          if (this.isDesktop) {
            if (respLayHist.layout && respLayHist.metadata) {
              const respLayout = await this.updateLayout(respLayHist.layout, respLayHist.metadata);
              if (respLayout) {
                this.clearLocalData();
              } else console.warn('[updateHistLayout] error on update historical layout to current layout data');
            } else {
              console.warn('[updateHistLayout] layout not found in historical data');
            }
          } else { 
            if (respLayHist.layout_mobile && respLayHist.metadata_mobile) {
              const respLayout = await this.updateLayout(respLayHist.layout_mobile, respLayHist.metadata_mobile);
              if (respLayout) {
                this.clearLocalData();
              } else console.warn('[updateHistLayout] error on update historical layout to current layout data');
            } else {
              console.warn('[updateHistLayout] layout_mobile not found in historical data');
            }
          }
        } catch (error) {
          console.log(err);
        }
      } else {
        console.warn('[tmnsdk] not started sdk');
      }
      // this.$store.commit('TOGGLE_CONTENT_OVERLAY', false);
    },
    restoreLayout() {
      if (this.tmnsdk) {
        console.log('[tmnsdk] calling restore layout');
        this.tmnsdk.restoreLayout();
      } else {
        console.warn('[tmnsdk] not started sdk');
      }
    },
    clearLocalData() {
      if (this.tmnsdk) {
        console.log('[tmnsdk] calling clear local data');
        this.tmnsdk.clearLocalData(true);
      } else {
        console.warn('[tmnsdk] not started sdk');
      }
    },
    initCheck() {
      console.log(`[checkToken] init interval`);
      this.checkTokenInterval = setInterval(() => {
        this.checkToken(false);
      }, 120 * 1000);
    },
    removeCheck() {
      console.log(`[checkToken] clear interval`);
      clearInterval(this.checkTokenInterval);
    },
    sessionCloseRefresh() {
      console.log(`[sessionCloseRefresh] refreshing token from session close`);
      const randomNum = getRandomNumberMinMax(7, 15);
      this.initComponentLoading = true;
      this.displayCannotLoadSystem = false;
      this.hasSessionClose = false;
      this.displayMaxConnections = false;
      this.displayInvalidCredentials = false;
      try {
        this.$vs.loading({
          container: "#crash-loading",
          scale: 0.6,
          background: 'transparent',
        });
      } catch (error) { }
      console.log(`[sessionCloseRefresh] requesting new token with random timeout: ${randomNum}s`);
      setTimeout(() => this.requestNewToken(), randomNum * 1000);
      // this.initCheck();
    },
    async logoutAcceptor() {
      console.log('[ACCEPTOR] init logout');
      await authService.logoutAcceptor();
    },
    getCurrentUser() {
      return localStorageHelper.getCurrentUser();
    },
    updateWdmaInfo(data) {
      localStorageHelper.updateWDMAInfo(data);
    },
    setVisibilityDetachedWindow(TMNCommodity, TMNContent) {
      if (TMNCommodity && TMNContent) {
        this.$store.dispatch("updateSubscribeToolsVisibility", false);
        this.$store.dispatch("updateNavMenuVisibility", false);
      }
    },
    getSubjects() {
      let subjects = [];
      if (!this.$store.state.AppActiveUser.rights) {
        return subjects;
      }

      this.$store.state.AppActiveUser.rights.forEach(item => {
        let itemSubject = this.subjectsTmn.get(item.mne);
        if (item.mne && itemSubject && item.habilitado) {
          subjects.push(itemSubject);
        }
      });

      return subjects;
    },
    checkAcceptorCredentials(acpurl, acptoken, domain) {
      return acpurl && acptoken && domain;
    },
    isWindowDetached() {
      return !!this.$route.query.currentCommodity;
    },
    navigateCurrentRoute() {
      const url = this.getUrlComm(this.currentCommodity, this.currentContent.nome);
      if (url) {
        this.currentRoute = url;
        if (this.tmnsdk) {
          this.tmnsdk.navigate(this.currentRoute);
        }
      }
    },
    initWDMA(acpurl, acptoken, domain) {
      const that = this;

      // Load metadata from server
      layoutService
        .loadLayoutWDMA(new URLSearchParams())
        .then(data => {
          // console.log("[isDesktop]", that.isDesktop);
          console.log("loadLayout for metadata: ", data);

          let metadata = "";
          if (that.isDesktop) {
            if (data && data.metadata && data.metadata.data) {
              metadata = data.metadata.data;
              console.debug("[TmnQuotes] Metadata: ", metadata);
            }
          } else {
            if (data && data.metadata_mobile && data.metadata_mobile.data) {
              metadata = data.metadata_mobile.data;
              console.debug("[TmnQuotes] Metadata: ", metadata);
            }
          }

          that.startSdk(acpurl, acptoken, domain, metadata);
        })
        .catch(error => {
          console.log("Error loadLayout", error);
        });
    },
    startSdk(acpurl, acptoken, domain, metadata) {
      if (!metadata || metadata.length === 0) {
        metadata = {};
      }
      // console.log('[TmnQuotes] Starting WDMA with metadata: ' + JSON.stringify(metadata));
      console.log(
        "[TmnQuotes] Starting WDMA with parameters: " +
        JSON.stringify({
          url: acpurl,
          container: "quotes-content", // id div
          default_route: null,
          news_subjects: this.subjects,
          detach: this.isWindowDetached(),
          metadata: metadata,
          domain: domain,
          theme: this.routeTheme,
          language: this.currentLang,
        })
      );
      this.displayCannotLoadSystem = false;
      this.initComponentLoading = false;
      this.tmnsdk = new WDMA.Plugin(this.wdmaPlugin(acpurl, acptoken, domain, metadata));

      // if (this.isDesktop) {
      //   this.tmnsdk = new WDMA.Plugin(this.wdmaPlugin(acpurl, acptoken, domain, metadata));
      // } else {
      //   this.tmnsdk = new WDMA.Plugin(this.wdmaPlugin(acpurl, acptoken, domain, metadata));
      // }
    },
    wdmaPlugin(acpurl, acptoken, domain, metadata) {
      const that = this;
      return {
        url: acpurl,
        container: "quotes-content", // id div
        default_route: null,
        news_subjects: this.subjects,
        detach: this.isWindowDetached(),
        metadata: metadata,
        domain: domain,
        theme: this.routeTheme,
        language: this.currentLang,

        onDetach: async function (detachWindow) {
          console.warn("[SDK]", "detach", detachWindow);

          // try {
          //   await this.logoutAcceptor();
          // } catch (error) {
          //   console.warn('[ACCEPTOR][ERROR][LOGOUT]', error);
          // }

          if (detachWindow) {
            // logger.logToServer({content: 'WDMA detached', user: that.getCurrentUser()});
            // localStorageHelper.updateQuotesPageDetach(true);
            that.$emit("detachSDK");
          } else {
            // localStorageHelper.updateQuotesPageDetach(false);
            window.close();
          }
        },

        onFullscreen: function (value) {
          if (value) {
            console.log("[TmnQuotes] onFullscreen: " + value);
            document.getElementById("quotes-content").requestFullscreen();
          } else {
            document.exitFullscreen();
          }
        },

        onError: function (message) {
          // sistema pronto para uso
          console.warn("[SDK]", "Error", message);

          // logger.logToServer({content: `Error: ${message}`, user: that.getCurrentUser()});

          // {"code":401,"success":false,"msg":"Session not found","status":20009,"acceptorId":"acceptor-safrasplatform-02","errors":[]}
          // Should request a new token
          if (
            [
              "emptyToken",
              "tokenExpired",
              "invalidToken",
              "failedConnection",
              "invalidDomain",
              "invalidLogin",
              "acceptorSessionNotFound"
            ].indexOf(message.errorCode) >= 0
          ) {
            console.log("Requesting a new token...");
            setTimeout(() => that.requestNewToken(), 15 * 1000);
          }
        },

        onReady: function (status) {
          console.warn("[SDK]", "onReady");
          if (!that.isDesktop) {
            console.log("[SDK]", "onReady Set theme", that.routeTheme);
            that.tmnsdk.setTheme(that.routeTheme);

            console.log("[SDK]", "onReady Set lang", that.currentLang);
            that.tmnsdk.setLanguage(that.currentLang);
            // logger.logToServer({content: 'OnReady', user: that.getCurrentUser()});
          }

          that.tmnsdk.connect(acptoken).then(() => {
            that.displayCannotLoadSystem = false;
            that.initComponentLoading = false;
            that.tmnsdk.getSessionInfo().then(function (data) {
              that.updateWdmaInfo(data);
              // logger.logToServer({content: 'Connected', user: that.getCurrentUser()});
            });

            if (that.currentRoute) {
              that.tmnsdk.navigate(that.currentRoute);
            } else {
              that.navigateCurrentRoute();
            }
          }).catch(err => {
            that.displayCannotLoadSystem = true;
            console.warn("[SDK]", "Error on sdk connect");
            console.warn("[SDK]", err);
          });

        },

        onConnect: function (status) {
          console.warn("[SDK]", "Connected");
        },
        onSessionClose: function (status) {
          console.warn("[SDK][onSessionClose]", "Sessão finalizada por outro terminal");
          // console.warn("[SDK][status]", status);
          localStorageHelper.clearAcceptorToken();
          that.removeCheck();
          that.hasSessionClose = true;
          that.displayMaxConnections = false;
          that.displayInvalidCredentials = false;
          that.displayCannotLoadSystem = false;
          that.initComponentLoading = false;
        },
        refreshLogin: function (status) {
          console.warn("[SDK]", "Refreshing session");
          console.warn("[SDK]", status);
          try {
            that.onRefreshToken();
          } catch (error) {
            console.warn("[Error][refreshToken][callFuntion] trying again", error);
            setTimeout(() => {
              that.onRefreshToken();
            }, 500);
          }
          // if (that.refreshToken) {
          //   console.warn("[SDK]", "Using a refresh token. System will reload with refresh token");
          //   console.warn("[SDK][REFRESH_TOKEN]", that.refreshToken);
          //   that.onRefreshToken();
          // } else {
          //   console.warn("[SDK][Refreshing session]", "Request a new token");
          //   that.requestNewToken();
          // }
        },
        onDisconnect: function (status) {
          console.warn("[SDK]", "Disconnected");
          // logger.logToServer({content: 'Disconnect', user: that.getCurrentUser()});
          console.log("Requesting a new token...");
          that.requestNewToken();
          setTimeout(() => that.requestNewToken(), 15 * 1000);
        },

        onChangeLayout: function (data) {
          console.debug("[SDK]", "Change Layout", data);

          if (data && data.layout && data.metadata) {
            that.updateLayout(data.layout, data.metadata);
            // localStorageHelper.updateMetadata(data.metadata);

            // const form = {
            //   layout: data.layout,
            //   metadata: data.metadata
            // };

            // layoutService
            //   .saveLayoutWDMA(form, new URLSearchParams())
            //   .then(() => {
            //     console.log("layout saved");
            //   })
            //   .catch(error => {
            //     console.log("Error change layout", error);
            //   });
          }
        },

        onGetLayout: function () {
          // console.debug("%c[SDK]", "Get Layout");
          console.log("[SDK] Get Layout");

          layoutService
            .loadLayoutWDMA(new URLSearchParams())
            .then(data => {
              console.log("loadLayout: ", data);
              if (that.isDesktop) {
                if (data.layout && data.layout.data) {
                  that.tmnsdk.setLayout(data.layout.data);
                }
              } else {
                if (data.layout_mobile && data.layout_mobile.data) {
                  that.tmnsdk.setLayout(data.layout_mobile.data);
                }
              }
            })
            .catch(error => {
              console.log("Error loadLayout", error);
            });
        }

        // onQuote: function (quote) {
        // console.info('[SDK]', 'OnQuote', quote);

        // $('.stock').html(quote.StockCode);
        // $('.description').html(quote.StockDetail);
        // $('.max').html(quote.Quote.HighPrice);
        // $('.min').html(quote.Quote.LowPrice);
        // $('.price').html(quote.Quote.LastTradePrice);
        // $('.ask').html(quote.Quote.AskPrice);
        // $('.bid').html(quote.Quote.BidPrice);
        // $('.average').html(quote.Quote.AvgPrice);
        // }
      }
    },
    processToken(data) {
      // User has to be logged in
      if (!localStorageHelper.getUserHasLoggedIn()) {
        return;
      }

      if (data.token && data.url) {
        // Update token and url in localstorage
        localStorageHelper.updateAcceptorData(data);
        this.displayCannotLoadSystem = false;
        this.initComponentLoading = false;
        this.displayMaxConnections = false;
        this.displayInvalidCredentials = false;
        this.hasSessionClose = false;

        if (this.tmnsdk) {
          this.tmnsdk.updateToken({ token: data.token });
          // this.tmnsdk.connect(data.token).then(() => {
          //   // console.log('tmnsdk connect currentRoute: ', this.currentRoute);
          //   this.tmnsdk.navigate(this.currentRoute);
          // });
        } else {
          this.initWDMA(data.url, data.token, data.domain);

          // ambiente local do vinicius testar na maquina dele
          // this.initWDMA('https://safras-single.cma.com.br', data.token, data.domain);

          // if (this.isDesktop) {
          //   this.initWDMA('https://wdma-dev.cma.com.br', data.token, data.domain);
          // } else {
          //   this.initWDMA('https://wdma-dev-5001.cma.com.br', data.token, data.domain);
          // }
        }
      } else {
        setTimeout(() => this.requestNewToken(), 60 * 1000);
      }
    },
    openAttendance(text) {
      EventBus.$emit(
        AppConstants.BUS_EVENT_OPENA_ATTENDANCE,
        text ? text : "Olá, estou com problemas para carregar as cotações."
      );
    },
    requestNewToken(hasLoading = false) {
      // User has to be logged in
      if (!localStorageHelper.getUserHasLoggedIn()) return;
      if (this.requestingToken) return;
      if (!this.displayCannotLoadSystem) {
        this.initComponentLoading = true;
      }
      // this.displayCannotLoadSystem = true;
      this.requestingToken = true;
      if (!hasLoading) {
        try {
          this.$vs.loading({
            container: "#crash-loading",
            scale: 0.6,
            background: 'transparent',
          });
        } catch (error) { }
      }

      this.refreshToken = '';
      acceptorService
        .requestNewToken({ ua: navigator.userAgent }, new URLSearchParams())
        .then(data => {
          try {
            this.$vs.loading.close("#crash-loading > .con-vs-loading");
          } catch (error) { }
          setTimeout(() => {
            this.displayCannotLoadSystem = false;
            this.initComponentLoading = false;
            this.displayMaxConnections = false;
            this.displayInvalidCredentials = false;
            this.hasSessionClose = false;
          }, 4000);
          this.requestingToken = false;
          this.processToken(data);
        })
        .catch(error => {
          try {
            this.$vs.loading.close("#crash-loading > .con-vs-loading");
          } catch (error) { }
          this.requestingToken = false;
          this.initComponentLoading = false;
          this.displayCannotLoadSystem = true;
          this.displayMaxConnections = false;
          this.displayInvalidCredentials = false;
          console.log("Error on requesting a new token", error);
          if (error.errors && error.errors.length > 0) this.currentErrorCode = error.errors[0].status;
          if (error.data && error.data.status) {
            if (tmnHelper.refreshToken(error)) {
              setTimeout(() => this.requestNewToken(), 15 * 1000);
              return;
            }
            if (tmnHelper.checkExpiredToken(error)) {
              setTimeout(() => this.onRefreshToken(), 15 * 1000);
              return;
            }
            if (tmnHelper.displayCannotLoadSystem(error)) {
              messagesNotifyHelper.errorNotify(
                this.$t('TOAST_NOTIFICATIONS').displayCannotLoadSystemTitle,
                this.$t('TOAST_NOTIFICATIONS').displayCannotLoadSystemMessage
              );
              return;
            }

            if (tmnHelper.displayNotAuthorized(error)) {
              messagesNotifyHelper.errorNotify(
                this.$t('TOAST_NOTIFICATIONS').displayCannotLoadSystemTitle,
                this.$t('TOAST_NOTIFICATIONS').displayCannotLoadSystemMessage
              );
              // messageDialogHelper.displayDialogConfirmWithText('Aviso', 'Não foi possível carregar o sistema. Entre em contato com Suporte ao Cliente.', 'Entrar em contato', () => {
              //   this.openAttendance();
              // });
              return;
            }
            if (tmnHelper.maxConnections(error)) {
              this.requestingToken = false;
              this.initComponentLoading = false;
              this.displayCannotLoadSystem = false;
              this.displayMaxConnections = true;
              this.displayInvalidCredentials = false;
              messagesNotifyHelper.errorNotify(
                this.$t('TOAST_NOTIFICATIONS').messagesNotifyHelperTitle,
                this.$t('TOAST_NOTIFICATIONS').messagesNotifyHelperMessage
              );
              // messageDialogHelper.displayDialogConfirmWithText('Aviso', 'Ocorreu falha de comunicação com o servidor, por favor atualize a pagina ou entre em contato com nossa equipe de Atendimento.', 'Entrar em contato', () => {
              //   this.openAttendance();
              // });
              return;
            }
            if (tmnHelper.invalidCredentials(error)) {
              this.requestingToken = false;
              this.initComponentLoading = false;
              this.displayCannotLoadSystem = false;
              this.displayMaxConnections = false;
              this.displayInvalidCredentials = true;
              messagesNotifyHelper.errorNotify(
                this.$t('TOAST_NOTIFICATIONS').messagesNotifyHelperTitle,
                this.$t('TOAST_NOTIFICATIONS').messagesNotifyHelperMessage
              );
              return;
            }
            // tmnHelper.checkNotifyErrors(error.data.status);
            // if (error.data.status == 20011) {
            //   messagesNotifyHelper.errorNotify('Erro', 'Ocorreu falha de comunicação com o servidor, por favor atualize a pagina ou entre em contato com nossa equipe de Atendimento pelo e-mail atendimento@cma.com.br.');
            //   return;
            // }
          }
          setTimeout(() => this.requestNewToken(), 15 * 1000);
        });
    },
    checkToken(processToken) {
      const { acpurl, acptoken, refresh_token, domain } = this.getCurrentUser();
      if (acptoken) {
        acceptorService
          .checkToken({ token: acptoken }, new URLSearchParams())
          .then(() => {
            console.log('[CHECK_TOKEN] ok');
            if (processToken) {
              console.log('[CHECK_TOKEN] processing token');
              const data = {
                url: acpurl,
                token: acptoken,
                refresh_token: refresh_token,
                domain: domain
              }
              this.processToken(data);
            }
          })
          .catch(async (error) => {
            console.log("Error on check token ", error);
            if (error.data && error.data.status) {
              if (tmnHelper.serviceUnavailable(error)) {
                this.requestingToken = false;
                this.initComponentLoading = false;
                this.displayCannotLoadSystem = true;
                this.displayMaxConnections = false;
                messagesNotifyHelper.errorNotify(
                  this.$t('TOAST_NOTIFICATIONS').displayCannotLoadSystemTitle,
                  this.$t('TOAST_NOTIFICATIONS').displayCannotLoadSystemMessage
                );
                return;
              }
              if (tmnHelper.checkInvalidToken(error)) {
                this.onInvalidToken();
                return;
              }
              if (tmnHelper.checkExpiredToken(error)) {
                this.onRefreshToken();
                return;
              }
              if (tmnHelper.checkSessionNotFound(error)) {
                this.requestNewToken();
                return;
              }
            }
          });
      } else {
        this.requestNewToken();
      }
    },
    onRefreshToken() {
      const { refresh_token } = this.getCurrentUser();
      console.warn("[REFRESH_TOKEN]", "Using a refresh token. System will reload with refresh token");
      console.warn("[REFRESH_TOKEN]", refresh_token);
      // User has to be logged in
      if (!localStorageHelper.getUserHasLoggedIn()) {
        return;
      }
      if (!refresh_token) {
        console.warn("[Refreshing session]", "Request a new token");
        this.requestNewToken();
        return;
      }
      try {
        this.$vs.loading({
          container: "#crash-loading",
          scale: 0.6,
          background: 'transparent',
        });
      } catch (error) { }
      this.refreshToken = '';
      acceptorService
        .refreshToken({ refresh_token }, new URLSearchParams())
        .then(data => {
          try {
            this.$vs.loading.close("#crash-loading > .con-vs-loading");
          } catch (error) { }
          const { acpurl } = this.getCurrentUser();
          data['url'] = acpurl;
          localStorageHelper.updateAcceptorData(data);
          if (this.tmnsdk) {
            this.tmnsdk.updateToken({ token: data.token });
          } else {
            this.processToken(data);
          }
        })
        .catch(error => {
          try {
            this.$vs.loading.close("#crash-loading > .con-vs-loading");
          } catch (error) { }
          console.log("Error on refresh token", error);
          if (error.data && error.data.status) {
            if (tmnHelper.checkInvalidToken(error)) {
              this.onInvalidToken();
              return;
            }
          }
          this.requestNewToken();
        });
    },
    async onInvalidToken() {
      console.log('[invalidToken] init logout and request new token');
      await this.logoutAcceptor();
      this.requestNewToken();
    },
    getUrlComm: function (commodity, content) {
      // console.log('[getUrlComm]');
      if (!commodity) {
        console.log("Erro: commodity nao valida", commodity);
        return null;
      }
      if (!content) {
        console.log("Erro: content nao valido", content);
        return null;
      }
      let commodityTmn, contentTmn;

      // subtract due to array index
      // let lang = localStorageHelper.getWdmaRoute() - 1;
      let wdmaRouteCode = localStorageHelper.getWdmaRoute();

      console.log(`[getUrlComm][commodity]`, commodity);
      console.log(`[getUrlComm][content]`, content);
      // console.log(`[getUrlComm][rights]`, commodity);

      // [2023-12-27] new rule
      const platformWdmaRoute = commodity.platformWdmaRoute.find(item => item.country.code == wdmaRouteCode);
      if (!platformWdmaRoute) {
        console.log("Erro: commodity não encontrado");
        return null;
      }
      commodityTmn = platformWdmaRoute.routeName;
      // if (
      //   this.conversionComm.hasOwnProperty(commodity) &&
      //   this.conversionComm[commodity][lang]
      // ) {
      //   commodityTmn = this.conversionComm[commodity][lang];
      // } else {
      //   console.log("Erro: commodity nao valida", commodity);
      //   return null;
      // }

      if (this.conversionContent["pt"].hasOwnProperty(content)) {
        contentTmn = this.conversionContent["pt"][content];
      } else if (this.conversionContent["en"].hasOwnProperty(content)) {
        contentTmn = this.conversionContent["en"][content];
      } else if (this.conversionContent["es"].hasOwnProperty(content)) {
        contentTmn = this.conversionContent["es"][content];
      } else {
        console.log("Erro: content nao valido", content);
        return null;
      }

      if (contentTmn === "Meus Ativos" || contentTmn === "My Assets") {
        if (!this.isDesktop) {
          console.log(`URL: /cotacoes/mySymbols`);
          return "/cotacoes/mySymbols";
        }
        console.log(`URL: /dashboard/quotes`);
        return "/dashboard/quotes";
      } else {
        if (!this.isDesktop) {
          console.log(`URL: /cotacoes/${commodityTmn}/${contentTmn}`);
          return `/cotacoes/${commodityTmn}/${contentTmn}`;
          // console.log(`URL: /dashboard/platform_categories_quotes/${commodityTmn}/${contentTmn}`);
          // return `/dashboard/platform_categories_quotes/${commodityTmn}/${contentTmn}`;
        }
        console.log(`URL: /dashboard/platform_categories_quotes/${commodityTmn}|${contentTmn}`);
        return `/dashboard/platform_categories_quotes/${commodityTmn}|${contentTmn}`;
      }
    }
  },
  beforeDestroy() {
    this.removeCheck();
  },
};
</script>

<style lang="scss" scoped>
/* CSS for the popup */
#content-area.content-area-lg {
  margin-left: 0 !important;
}

.router-view {
  padding: 0 !important;
}

/*.corner-ribbon.top-left {*/
/*  display: none !important;*/
/*}*/
/*#signature-tools {*/
/*  display: none;*/
/*}*/
</style>
